<vl-region v-if="responders || klimData">
    <vl-layout>
        <vl-title tag-name="h2">Betrokken leidingbeheerders</vl-title>
        <vl-typography v-if="unaUnknown">
            <p>Betrokken leidingbeheerders nog niet gekend.</p>
        </vl-typography>
        <kl-maprequest-una-table v-else>
            <template v-slot:header>
                <kl-una-alert
                    :help-link="helpLink"
                    :icon="unaAlert.icon"
                    :mod-error="unaAlert.status === 'error'"
                    :mod-success="unaAlert.status === 'success'"
                    :mod-warning="unaAlert.status === 'warning'"
                    v-if="unaAlert" mod-colored>{{ escapeText(unaAlert.message) }}
                </kl-una-alert>
            </template>
            <template v-if="unaResponders">
                <kl-accordion
                    v-for="item in unaResponders"
                    :key="`${item.title}#${item.subtitle}`"
                    :title="item.title"
                    :subtitle="item.subtitle"
                    :mod-error="item.error"
                    :mod-success="item.success">
                    <kl-contact-card
                        v-if="item.contact"
                        :title="item.contact.title"
                        :phone="item.contact.phone"
                        :email="item.contact.email"
                        :emergency-phone="item.contact.emergencyPhone"
                        mod-email-clickable />
                    <kl-una-alert
                        v-if="item.statusMessage"
                        :mod-error="item.error"
                        :mod-success="item.success"
                        :help-link="helpLink">
                        {{ escapeText(item.statusMessage) }}
                    </kl-una-alert>
                </kl-accordion>
            </template>
            <template v-slot:footer>
                <kl-una-message :title="klimMessage.title" :content="klimMessage.content" v-if="klimMessage"/>
            </template>
        </kl-maprequest-una-table>
    </vl-layout>
</vl-region>
